// <- TaskManagment.js
import React, { useState, useEffect, Fragment,useRef } from "react";
import { Button, Input, Row, Col, Form } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import moment from 'moment';
import "../../../style/calendarclass.css";
import useFormValidation from "../../common/useFormValidation";
import AddDeleteTableRowsTask from "../../../pages/tasks/AddDeleteTableRowsTask";
import Notifications from "../../../components/common/Notifications";
import {
  PopUpLeave,
  PopUpSuccess,
} from "../../../components/adminSettings/index";
const loginUser = JSON.parse(localStorage.getItem("user"));
let allowedDates=[];

const AddEditLeave = React.memo(
  ({
    handleClsAddEditTaskForm,
    handleAddUpdateTask,
    selectedTask,
    taskProjectInfo,
    addOrEdit,
    getAllTaskOfEmployee,
    setIsOpenAddEditForm,
    unlockReqList,
    LeaveReq,
    handleCloseAddEditForm,
    datearraylast,
    datearray,
    datearraylastAll,
    handleAddUpdateLeave,
    empTask,
    leaveList
  }) => {
    const [workDate, setWorkDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(new Date());
    const [taskTitle, setTaskTitle] = useState("");
    const [hourSpent, setHourSpent] = useState("");
    const [hourBillable, setHourBillable] = useState("");
    const [estimatedHour, setEstimatedHour] = useState("");
    const [status, setStatus] = useState("1");
    const [description, setDescription] = useState("");
   // const [taskId, setTaskId] = useState("");
    const[leaveStatus,setLeaveStatus] = useState(0);
    const[leaveType,setLeaveType] = useState(0);
    const [workTime, setWorkTime] = useState("09:30");
    const dates = [];
    const [leaveReq,setleaveReq]=useState([]);
    const [employeeFormValidation, setEmployeeFormValidation] = useState({});
    const [tasttrackingList, setTaskTrackingList] = useState([]);
    const [tasktrackList,settasktrackList] =useState([]);
    const [error, setError] = useState(null);
    const callValidation = useRef(false);
    const errorRef = useRef(null);
    const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  //---------------set Calendar Enable Dates-----------------------------
  var currd = new Date;  
  const t =new Date(currd.setDate(currd.getDate() - currd.getDay()+1)).getDate();
    const { formValidation, isFormValid } = useFormValidation(
      employeeFormValidation
    );

  var firstday = new Date(currd.setDate(currd.getDate() - currd.getDay()+1)).getDate();
  let lastFriday = new Date();
  let lastFridayl = new Date();
  lastFridayl.setDate(t);
  if(unlockReqList!=null && unlockReqList.length!=0 && unlockReqList[0]!=''){
    unlockReqList.map((emp, i) => { 
      let fromDate = emp.fromDate;
      let toDate = emp.toDate;
    
 
    
    var dateParts = fromDate.split("-");
    var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
    lastFriday = jsDate;
    let range= getDatesInRange(fromDate,toDate,lastFridayl);
    allowedDates=range;

  })
  }
  else
  {
    var curr = new Date();  
    let fromDate =new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
    // let fromDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    let toDate =  new Date();
    toDate.setDate(toDate.getDate() + 7);;
    // var dateParts = fromDate.split("-");
    // var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
    // lastFriday = jsDate;
    let range= getDatesInRange(fromDate,toDate,lastFridayl);
    allowedDates=range;
  }

  function getDatesInRange(startDate, endDate,lastFriday) {
    const date = new Date(startDate);
    const datela=new Date(lastFriday);
    const endlast=new Date(lastFriday.setMonth(lastFriday.getMonth() + 12));
 
   while (date <= new Date(endDate)) {
     dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
     date.setDate(date.getDate() + 1);
   }
   while(datela <= new Date(endlast))
   {
     dates.push(moment(new Date(datela)).format("YYYY-MM-DD"));
     datela.setDate(datela.getDate() + 1);
   }
 
   return dates;
 }

    //-------------------------------------------------------------------
  //   useEffect(()=>{   
  //     if(goalsAchieved!=undefined && goalsAchieved?.goalsAchievedList?.length>0){
  //         setGoalsAchievedList(goalsAchieved.goalsAchievedList);
  //         //console.log(goalsAchieved)
  //     }
  // },[goalsAchieved]);
    useEffect(() =>{
      callValidation.current && handleSubmitForm();
     
    },[formValidation]);

    const formValidationOnSubmit = (e) => {
      e.preventDefault();
      let formValidationList = {
        taskTitle: {
          required: true,
          isValid: true,
          value:parseInt(leaveType)===2 ? "Full Day Leave" : "Half Day Leave",
          errorMessage: "",
        },
        workTime:{
          required: true,
          isValid: true,
          value: workTime,
          errorMessage: "",
        },
        hourSpent:{
          required: true,
          isValid: true,
          value:parseInt(leaveType)===2 ? 8 : (parseInt(leaveType)===1 ? 4 :hourSpent ) ,
          errorMessage: "",
        },
        hourBillable:{
          required: true,
          isValid: true,
          value:parseInt(0) ,
          errorMessage: "",
        },
        estimatedHour:{
          required: true,
          isValid: true,
          value:parseInt(0),
          errorMessage: "",
        },
        description:{
          required: true,
          isValid: true,
          value: description,
          errorMessage: "",
        },
      };
      setEmployeeFormValidation(formValidationList); //this set call the custom hook useFormValidation.
      callValidation.current = true;
    };
    useEffect(() => {
      const element = document.getElementById('topview');
      element.scrollIntoView();
      setleaveReq(LeaveReq);
  
      if (addOrEdit === "edit" && selectedTask!=null) {       
        setTaskTitle(selectedTask.issueTitle);
        setWorkDate(new Date(selectedTask.workDate));
        setDueDate(new Date((selectedTask.dueDate === "0001-01-01T00:00:00" || selectedTask.dueDate === undefined) ? selectedTask.workDate : selectedTask.dueDate));
        setHourSpent(selectedTask.hoursSpent);
        setHourBillable(selectedTask.hoursBillable);
        setEstimatedHour(selectedTask.estimatedHour)
        setStatus(selectedTask.timeSheetStatus);
        setDescription(selectedTask.description);
        setLeaveStatus(selectedTask.leaveStatus);
        setLeaveType(selectedTask.leaveType);
        settasktrackList(selectedTask.employeeTimeSheetStatuses);
        // const time=selectedTask.startTime.split(' ');
        // const stime=time[1];
        setWorkTime("10:00");
      //  setTaskId(selectedTask.employeeTimeSheetId);
      } else {
        setTaskTitle("");
        setWorkDate(new Date());
        setDueDate(new Date());
        setHourSpent("");
        setHourBillable("");
        setStatus("1");
        setDescription(" ");
        setLeaveStatus(0);
        setLeaveType(0);
        settasktrackList([]);
        setEstimatedHour("");
      }
    }, [selectedTask, addOrEdit,LeaveReq]);
    var array = ["2023-05-16", "2023-05-12", "2023-05-15"];
    // var value1 = "2023-05-12"; 
    function isInArray(LeaveReq, value) {
      // const flatArray =  LeaveReq.some(LeaveReqss => LeaveReqss.employeeTimeSheetStatuses.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value));
      // const newlist= LeaveReq.some(employee =>
      //   employee.employeeTimeSheetStatuses.find(item => moment(item.statusDate).format("YYYY-MM-DD") === value)
      // );
      for (const employee of LeaveReq) {
        if (moment(employee.workDate).format("YYYY-MM-DD") == value) {
          return employee;
        }
      }
      // const newlist=LeaveReq.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value);
      // const newlist= LeaveReq.some(innerArray => innerArray.includes(value));
      return null; 
    }
    function isInLeaveArray(LeaveReq, value) {
      // const flatArray =  LeaveReq.some(LeaveReqss => LeaveReqss.employeeTimeSheetStatuses.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value));
      // const newlist= LeaveReq.some(employee =>
      //   employee.employeeTimeSheetStatuses.find(item => moment(item.statusDate).format("YYYY-MM-DD") === value)
      // );
      for (const employee of LeaveReq) {
        if (moment(employee.workDate).format("YYYY-MM-DD") == value) {
          return employee;
        }
      }
      // const newlist=LeaveReq.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value);
      // const newlist= LeaveReq.some(innerArray => innerArray.includes(value));
      return null; 
    }
    // Functions.
    // handle change date in DOJ
    const handleConvertToLeaves = React.useCallback(
      () => {
      
        setisopenpopup((prevState) => !prevState);
        
      },
      []
    );
    const hadleDelWithPopYes =React.useCallback(() =>{
      // const res= delOfficeLoation(curDelId);
      setLeaveType(2);
      setisopenpopup((prevState) => !prevState);
      }, [setLeaveType,setisopenpopup]);
    
    const hadleDelWithPopNo =React.useCallback(() =>{
     setisopenpopup((prevState) => !prevState);
    
    });
      
    const hadleSuccessPop =React.useCallback(() =>{
     setisopenpopupSuccess((prevState) => !prevState);
     
    window.location.reload();
    },[]);

    const handleChangeStartDate = (date) => {
      
      const gghh=empTask;
      const newleaveList=leaveList[0];
      const value1=moment(date).format('YYYY-MM-DD');
      const status=isInArray(empTask, value1);
      const leavestatus=isInLeaveArray(newleaveList,value1);
      if(leaveType == 0)
      {
        setError({ ...error, message: "First choose leave type..", status: 500 });
      }
      else
      {
        if(status != null)
          {
            if(leaveType == '2')
              {
                setError({ ...error, message: "Task Already Added. You Can't Apply FullDay Leave..", status: 500 });
                setWorkDate(new Date());
              }
           else
           {
            if(status.leaveType == 1)
            {
              handleConvertToLeaves();
            }
            else{
              setError({ ...error, message: "Task Already Added. You Can't Apply HalfDay Leave..", status: 500 });
              setWorkDate(new Date());
            }
         
           }
          //   setLeaveType(0);
          //   setLeaveStatus(false);
          }
          else
          {
            setWorkDate(date); 
          }
         
          if(leaveStatus != null && leaveStatus != 0)
          {
            if(leaveType == '1')
              {
                handleConvertToLeaves();
                
              }
            if(leaveType == '2')
              {
            setError({ ...error, message: "Leave Already Added..", status: 500 });
            setWorkDate(new Date());
              }
          }
      }
      
    };
    const handleChangeDueDate =React.useCallback ((date) => {
      setDueDate(date);
      const nn=workDate;
      const value1=moment(date).format('YYYY-MM-DD');
      const status=isInArray(LeaveReq, value1);
      if(date<workDate)
      {
        setError({ ...error, message: "Please Select A Due Date Later Than Or Equal To The Creation Date..", status: 500 });
        setDueDate(new Date());
      }
      if(status==false)
      {
        setLeaveType(0);
        setLeaveStatus(false);
      }
      else
      {
        setLeaveType("2");
        setLeaveStatus(true);
      }
    },[setLeaveType,setLeaveStatus,LeaveReq,workDate]);
    const handleChangeStartTime = (date) => {
      setWorkTime(date.target.value);
    };
    const inputDateFormatString = (workDate)=>{
      var year = workDate.getFullYear();
      var month = workDate.getMonth() + 1;
      if(month <= 9)
          month = '0'+month;
      var day= workDate.getDate();
      if(day <= 9)
          day = '0'+day;
          var prettyDate = year +'-'+ month +'-'+ day;
          return prettyDate;
    };
    const mark = [
      '12-05-2023'
  ];
  const handledelteall =() =>{
    setTaskTitle("");
    setWorkDate(new Date());
    setDueDate(new Date());
    setHourSpent("");
    setHourBillable("");
    setStatus("1");
    setDescription(" ");
    setLeaveStatus(0);
    setLeaveType(0);
    settasktrackList([]);
    setEstimatedHour("");
  }
    // handle form submite.
    const handleSubmitForm = (e) => {
      //  e.preventDefault();    
      if (isFormValid) {
        let timetrackArray = [];
        // if(addOrEdit === "edit")
        // {
        for(var i=0;i<tasttrackingList.length;i++){
 
          
         let timetrack_data = {
              // "goalsAchievedId":goalsAchievedArr[i].goalAchievedId?goalsAchievedArr[i].goalAchievedId: 0,
              "employeeTimeSheetId" : addOrEdit === "edit" ? selectedTask.employeeTimeSheetId : 0,
              "status" :parseInt(tasttrackingList[i].status) ,
              "employeeId" : parseInt(loginUser.EmployeeId),
              "statusDate": tasttrackingList[i].startdate,
              "hoursLogged":parseFloat(tasttrackingList[i].hoursspent),
              "hoursBillable":parseFloat(tasttrackingList[i].hoursbillable),
              "description":tasttrackingList[i].description,
              // "reviewerComment":goalsAchievedArr[i].comments      
            }
            timetrackArray.push(timetrack_data);
      }
    // }


      let formDate = {
        employeeTimeSheetId: addOrEdit === "edit" ? selectedTask.employeeTimeSheetId
        : 0,
        employeeID: parseInt(loginUser.EmployeeId),
        workDate:inputDateFormatString(workDate),
        projectID: taskProjectInfo.projectId,
        issueID:0,    
        description:description,    
        hoursSpent: parseInt(leaveType)===2 ? 8 : (parseInt(leaveType)===1 ? 4 :hourSpent ),
        hoursBillable: parseFloat(0),
        estimatedHour: parseFloat(0),
        projectIssueStatus:1,
        endDate:inputDateFormatString(workDate),
        dueDate:inputDateFormatString(dueDate),
        timeSheetStatus:parseInt(status),
        createdBy: parseInt(loginUser.EmployeeId),
        createdDate:inputDateFormatString(new Date()),
        modifiedBy:parseInt(loginUser.EmployeeId),
        modifiedDate:inputDateFormatString(new Date()),
        issueTitle:parseInt(leaveType) === 1 ? "Half Day Leave on "+moment(workDate).format("DD-MM-YYYY") :(parseInt(leaveType) === 2 ? "Full Day Leave on "+moment(workDate).format("DD-MM-YYYY") :"Attendence Override on "+moment(workDate).format("DD-MM-YYYY"))  ,
        assignedTo:parseInt(loginUser.EmployeeId),
        projectName: taskProjectInfo.projectName,
        // taskId:
        // addOrEdit === "edit"
        //   ? selectedTask.employeeTimeSheetId
        //   : Math.floor(Math.random() * 100) + 1,
        leaveStatus : true,
        leaveType : parseInt(leaveType),
        startTime : workTime,
        EmployeeTimeSheetStatuses:timetrackArray,
      };


     const value1=moment(workDate).format('YYYY-MM-DD');
      const statusn=isInArray(empTask, value1);
      const newleaveList=leaveList[0];
      const leavestatus=isInLeaveArray(newleaveList,value1);
      if(statusn != null)
      {
        if(leaveType == '2')
          {
if(leavestatus !=null && leavestatus.leaveType == 1)
{
  handleAddUpdateLeave(formDate);
  settasktrackList([]);
  handledelteall();
  callValidation.current=false;
}
else
{
  setError({ ...error, message: "Task Already Added. You Can't Apply FullDay Leave..", status: 500 });
            setWorkDate(new Date());
            callValidation.current=false;
}
          

          }
       else
       {
        handleAddUpdateLeave(formDate);
      settasktrackList([]);
      handledelteall();
      callValidation.current=false;

       }
      //   setLeaveType(0);
      //   setLeaveStatus(false);
      }
      else
      {
        handleAddUpdateLeave(formDate);
      settasktrackList([]);
      handledelteall();
      callValidation.current=false;
      }
     
      //EmployeeTimeSheetStatuses getAllTaskOfEmployee(parseInt(loginUser.EmployeeId));
    }
   
    };
    const handlecloseform =(e) =>{
      setEstimatedHour("");
      handleCloseAddEditForm(e);
      handledelteall();
      setEmployeeFormValidation({});
    }
    const handelcancel=(e) =>{
      // handlecloseform(e);
      handleClsAddEditTaskForm(e);
      handleCloseAddEditForm(e);
      setWorkTime("10:00");
      handledelteall();
      settasktrackList([]);
      setEmployeeFormValidation({});
    }
    const [time, onChange] = useState('10:00');
    
const setData = (data)=>{
  setTaskTrackingList(data)
  }
  const handletotcal =(name,value) =>{
    if(name==="hoursspent")
    {
      
        setHourSpent(value);
           
    }
    else if(name==="hoursbillable")
    {
      setHourBillable(value);
    }
    else if(name==="status")
    {
      setStatus(value);
    }
// alert("1");
  }
  useEffect(()=>{   
    errorRef.current.scrollIntoView();
});

    return (
      <Fragment>
        <Form>
        <div ref={errorRef}>
        <div className="fixed-header" style={{height:"45px"}}>
            <div>
              <div  size="sm" outline className="secondary"><h6>Mark Leave</h6></div>
             
              <div className="d-inline float-right " style={{marginTop:"-33px"}}>
                <Button color="" onClick={(e) => handlecloseform(e)}>
                  <i className="fas fa-times text-muted"></i>
                </Button>
              </div>
            </div>
          </div>
         <div>
          <div className="task-details">
            <div className="chat-wrap-inner">             
              <div className="chats">    
                        
            <br/>
                <div className="task-data ">
                 
                   <li >
                      <div className="title" style={{marginLeft :"16px"}}>Leave Type</div>
                      <div className="text" style={{marginLeft :"16px"}}>
                      <Input
                          type="select"
                          onChange={(e) => setLeaveType(e.target.value)}
                        >
                          <option
                            value="0"
                            selected={leaveType == "0" ? true : null}
                          >
                           Select
                          </option>
                          <option
                            value="1"
                            selected={leaveType == "1" ? true : null}
                          >
                            Half Day
                          </option>
                          <option
                            value="2"
                            selected={leaveType == "2" ? true : null}
                          >
                            Full Day
                          </option>
                          <option
                            value="3"
                            selected={leaveType == "3" ? true : null}
                          >
                            Attendance Override
                          </option>
                        </Input>
                      </div>
                    </li> 
                    <br/>
                    <tr className=" txttask ultask">
                      
                      
                    <div className="task-header">
                    <td>
                 <div className="task-due-date">
                  
                   <div className="due-info">
                     <div className="task-head-title">Leave On</div>
                     <div className="due-date" style={{width : "320px"}}>
                       <DatePicker 
                         selected={new Date(workDate)}
                         onChange={handleChangeStartDate}
                         dateFormat="dd-MM-yyyy"
                         // minDate={lastFriday}
                         // includeDates={allowedDates}
                         filterDate={(d) => allowedDates.includes(moment(d).format('YYYY-MM-DD')) }
                         disabled={addOrEdit === "edit" ? true : false}
                       />
                     </div>
                   </div>

          
                 </div>     
                 </td>
               
                 <td style={(leaveType == "1" || leaveType == "3") ?({visibility:"visible"}) :({visibility:"hidden"}) }>
                  <div className="task-due-date">
                  
                   <div className="due-info">
                      <div className="task-head-title">Hours Spent</div>
                      <div className="due-date" style={{width : "380px"}}>
                        <Input
                          type="text"
                          onChange={(e) => setHourSpent(e.target.value)}
                          value={((leaveType=="2" || leaveType == "3" ) && leaveStatus == true) ? 0 : hourSpent}
                          // disabled = {((leaveType == "2" && leaveStatus == true) ? "disabled" : null)}
                       name="hourSpent"
                       className=" txttask_text"
                      //  disabled={true}
                       />
                      </div>
                      </div>
                      </div>
                      {Object.keys(formValidation).length !== 0 &&
              !formValidation.hourSpent.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.hourSpent.errorMessage}
                </span>
              )}
                      </td>
                     
               </div>
               </tr>
                    <tr className=" txttask ultask">
                      
                     
                     
                    </tr>
                    {/* <ul className="personal-info">
                  </ul> */}
                  <div className="p-2 ">
                    <span className="description-title" style={{marginLeft:"12px"}}>Description</span>
                    <span className="description w-100 project-description">
                      <Input
                      className="textaresize"
                        type="textarea"
                        onChange={(e) => setDescription(e.target.value)}
                        value={description}
                        // disabled = {((leaveType == "2" && leaveStatus == true) ? "disabled" : null)}
                      name="description"
                      style={{marginLeft:"14px"}}
                      />
                    </span>
                    {Object.keys(formValidation).length !== 0 &&
              !formValidation.description.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.description.errorMessage}
                </span>
              )}
                  </div>
           
                  <Row>
                    <Col className="text-center mt-2">
                      <Button
                        type="submit"
                        color=""
                        className="btn-admin-settings"
                        onClick={(e) => formValidationOnSubmit(e)}
                        // disabled = {((leaveType == "2" && leaveStatus == true) ? "disabled" : null)}
                      >
                        {/* {selectProject ? "Update" : "Add"} */}
                        {addOrEdit === "add" ? "Add" : "Update"}
                      </Button>
                      &nbsp;
                      <Button
                        color=""
                        className="btn-cancel"
                        onClick={(e) => handelcancel(e)}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </Form>
        <Notifications notifications={error}></Notifications>
        {isopenpopup == true ? (<PopUpLeave 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUpLeave>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
      </Fragment>
    );
  }
);
export default AddEditLeave;
